<template>
  <div class="log-container">
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item prop="name" label="日志名称">
              <el-input v-model.trim="queryForm.name" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="visType" label="访问类型">
              <el-select v-model="queryForm.visType" placeholder="请选择">
                <el-option label="登入" value="1"></el-option>
                <el-option label="登出" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="success" label="是否成功">
              <el-select v-model="queryForm.success" placeholder="请选择">
                <el-option label="是" value="Y"></el-option>
                <el-option label="否" value="N"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" style="margin-right: 6px;" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-col>
          <el-col :span="6">
            <el-button
              type="danger"
              style="float: right;"
              :disabled="!multiSelectedList.length"
              @click="confirmDelete"
            >清空日志</el-button>
            <el-button
              type="success"
              style="float: right; margin-right: 16px;"
              :loading="exportBtnLoading"
              @click="handleExportLog"
            >{{exportBtn}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表格区域 -->
    <div class="table">
      <el-table
        :data="accessLogList"
        v-loading="tableLoading"
        @selection-change="handleSelectionChange"
        stripe
        border
      >
        <el-table-column type="selection" width="60" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="name" label="日志名称" align="center" :resizable="false"></el-table-column>
        <el-table-column prop="visType" label="访问类型" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <span>{{row.visType === 1 ? '登入' : '登出'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="success" label="是否成功" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <span>{{row.success === 'Y' ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ip" label="IP" align="center"></el-table-column>
        <el-table-column prop="browser" label="浏览器" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="visTime" label="访问时间" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="account" label="访问人" align="center"></el-table-column>
        <el-table-column prop="message" label="具体消息" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import logApi from 'api/home/log-management.js';
import config from '@/config/index.js';

export default {
  data() {
    return {
      total: 0,
      queryForm: {
        pageNo: 1,
        pageSize: 10,
        success: '',
        visType: '',
        name: ''
      },
      tableLoading: true,
      accessLogList: [],
      multiSelectedList: [],
      exportBtnLoading: false,
      exportBtn: '导出数据'
    };
  },
  created() {
    this.getAccessLogListData();
  },
  methods: {
    // 获取访问日志列表
    getAccessLogListData() {
      this.tableLoading = true;
      logApi
        .getAccessLogList(this.queryForm)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.data.totalRows;
            this.accessLogList = res.data.data.rows;
          }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.getAccessLogListData();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 10;
      this.getAccessLogListData();
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNo = 1;
      this.getAccessLogListData();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getAccessLogListData();
    },
    // 表格选择事件
    handleSelectionChange(selectedList) {
      this.multiSelectedList = [];
      this.multiSelectedList = selectedList.map(item => {
        return item.id;
      });
    },
    // 确认删除所选日志
    confirmDelete() {
      this.$confirm('确定清空所选日志？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          logApi
            .postDeleteAccessLog({
              idList: this.multiSelectedList
            })
            .then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.handleSearch();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除'
          });
        });
    },
    // 导出日志
    handleExportLog() {
      this.exportBtnLoading = true;
      this.exportBtn = '导出中...';
      logApi
        .getExportAccessLog(this.queryForm)
        .then(res => {
          // console.log(res);
          // return;
          // if (res.status !== 200) {
          //   this.exportBtnLoading = false;
          //   this.exportBtn = '导出数据';
          //   this.$message({
          //     type: 'error',
          //     message: '导出数据失败'
          //   });
          //   return;
          // }

          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          let h = JSON.stringify(res.headers);
          let j = JSON.parse(h);
          let fileName = decodeURI(j['content-disposition'].split('attachment; filename=')[1]);
          fileName = fileName.replace(/\"/g, '');
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          // debugger;
          link.click();
          window.URL.revokeObjectURL(link.href);
          this.exportBtnLoading = false;
          this.exportBtn = '导出数据';
          this.$message({
            type: 'success',
            message: '导出数据成功'
          });
        })
        .catch(err => {
          this.exportBtnLoading = false;
          this.exportBtn = '导出数据';
        });
    }
  }
};
</script>

<style lang="less" scoped>
.log-container {
  padding: 16px;

  .query-nav {
    height: 40px;
  }

  .page {
    margin: 16px 0;
    float: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
